import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { TransactionService } from 'app/services/models/transaction.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-expense-transaction-list',
  templateUrl: './expense-transaction-list.component.html',
  styleUrls: ['./expense-transaction-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpenseTransactionListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  public searchValue = '';
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;
  constructor(private transactionService: TransactionService, private router: Router) { }

  async ngOnInit() {
    await this.getAllTransaction(0, 5, '');
  }

  onActivate(event: any) {
    if (event.type === 'click' && event.row) {
      console.log(event.row);
      if (event.row.companyId == 2) {
        this.router.navigate([`/admin/mexpensetransaction-update/${event.row.id}`]);

      }else{
        this.router.navigate([`/admin/buying-detail/${event.row.id}`])
      }
    }
  }

  async getAllTransaction(page, size, search) {
    this.blockUI.start('Masraflar yükleniyor..')
    const data = await this.transactionService.GetTransactionManagementExpenseList(page, size, search);
    console.log(data);
    this.totalCount = data.totalCount;
    this.rows = data.expenseListTransactions;
    this.blockUI.stop();
  }

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.searchValue = val;
    setTimeout(async () => {

      await this.getAllTransaction(this.pageBasic - 1, this.selectedSize, this.searchValue);
    }, 500);
  }



  async onPageChange(pageNumber: number) {
    await this.getAllTransaction(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllTransaction(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }


}
